import { CUSTOM_CODE_STATUS, ICommonState } from '@store/types/common';

export default (): ICommonState => ({
  loader: false,
  codeTypes: [],
  customCodeStatus: CUSTOM_CODE_STATUS.noCheck,
  isOpenGenerateCode: false
});
